import { platformApiFetch } from '@/services/platformApi/client';
import { debugLogger } from '@/utils/debug';

export interface ProviderStatus {
  isAdmin: boolean;
  hasActiveSubscription: boolean;
  isPremium: boolean; // derived
  tier: string;
}

const STATUS_TTL = 5 * 60 * 1000; // 5 minutes
const statusCache = new Map<string, { data: ProviderStatus; ts: number }>();

export async function fetchProviderStatus(userId: string): Promise<ProviderStatus | null> {
  if (!userId) return null;
  const cached = statusCache.get(userId);
  const now = Date.now();
  if (cached && now - cached.ts < STATUS_TTL) return cached.data;
  try {
    const status = await platformApiFetch<ProviderStatus>(`/v1/provider-status/${userId}`);
    if (!status) {
      return {
        isAdmin: false,
        hasActiveSubscription: false,
        isPremium: false,
        tier: 'free_tier',
      };
    }

    statusCache.set(userId, { data: status, ts: now });
    return status;
  } catch (e) {
    debugLogger.error('fetchProviderStatus exception', e);
    return {
      isAdmin: false,
      hasActiveSubscription: false,
      isPremium: false,
      tier: 'free_tier',
    };
  }
}

export function invalidateProviderStatus(userId: string) {
  statusCache.delete(userId);
}
